import React, { useState } from 'react';
import "./style.css"
import { useAuth } from '../../Context/UserContext/index.tsx';
const DeclarationForm = () => {
    const {batchNo,username,courseId} =useAuth()
  const [candidateName, setCandidateName] = useState('');
  const [candidateNric, setCandidateNric] = useState('');
  const [date, setDate] = useState('');
  const [acceptedAll, setAcceptedAll] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);
  const [attendance, setAttedance] = useState(false);
  const [answers, setAnswers] = useState([]);

  const questions = [
    "I have a tablet/computer/smartphone that is able to access the software",
    "I have access to Internet at the place of my course attendance.",
    "I have access to soft copy of notes before class.",
    "I am aware that Attendance taking should be carried out based on trainee’s ID via NRIC or FIN.",
    "I am aware of the lesson plan for this Course.",
    "I am aware of the lessons and Learning Activities in this Course.",
    "I am aware of the assessments in this Course.",
    "I am aware of the online feedback in this course.",
    "I am aware of the Recording of all online sessions for audit purposes.",
    "I am aware of the need to switch on their webcams for the invigilator to monitor them while they take the online assessment.",
    "I am aware that any malpractice will be reported to the relevant authorities."
  ];

  // Initialize answers with null for each question
  React.useEffect(() => {
    setAnswers(Array(questions.length).fill(null));
  }, []);

  const handleRadioChange = (questionIndex, value) => {
    const updatedAnswers = [...answers];
    updatedAnswers[questionIndex] = value;
    setAnswers(updatedAnswers);
  };

  const handleAcceptAll = () => {
    const allYes = Array(questions.length).fill('YES');
    setAnswers(allYes);
    setAcceptedAll(true);
  };

  const handleConsentChange = (e) => {
    setConsentChecked(e.target.checked);
  };

const handleSubmit = async () => {
  if (!acceptedAll || answers.includes(null)) {
    alert('Please accept all terms and ensure all questions are answered YES before submitting.');
    return;
  }

  if (!consentChecked) {
    alert('Please consent to the collection of your personal data.');
    return;
  }

  try {
    const response = await fetch('https://elearn-api.onrender.com/api/insertAttendance', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        NricId: username,
        BatchNo: batchNo,
        SignSignature: '1',
      }),
    });

    const data = await response.json();

    if (response.ok) {
      setAttedance(true);
      setAnswers([]);

      // ✅ Call your sts update API here
      await fetch(`https://elearn-api.onrender.com/api/increment-currentsts/${username}/${batchNo}/${courseId}`, {
        method: 'POST',
      });

    } else {
      alert('Failed to submit attendance.');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Something went wrong.');
  }
};

  
  
  return (
    <div className="declaration-form">
      <h5>ONLINE COURSE DECLARATION</h5>

      {/* Ca/ndidate Info */}
      {/* <div className="candidate-info">
        <label>Candidate Name:</label>
        <input 
          type="text" 
          value={candidateName} 
          onChange={(e) => setCandidateName(e.target.value)} 
          placeholder="Enter the Name" 
          readOnly 
        />
        <label>Candidate NRIC:</label>
        <input 
          type="text" 
          value={candidateNric} 
          onChange={(e) => setCandidateNric(e.target.value)} 
          placeholder="Enter the NRIC" 
          readOnly 
        />
        <label>Date:</label>
        <input 
          type="date" 
          value={date} 
          onChange={(e) => setDate(e.target.value)} 
        />
      </div> */}

      {/* Declaration Questions */}
      <div className="questions">
        {questions.map((question, index) => (
          <div key={index} className="form-group">
            <label>{`${index + 1}. ${question}`}</label>
            <div>
              <input
                type="radio"
                name={`q1_${index + 1}`}
                value="YES"
                checked={answers[index] === 'YES'}
                onChange={() => handleRadioChange(index, 'YES')}
              />
              <label>YES</label>
              <input
                type="radio"
                name={`q1_${index + 1}`}
                value="NO"
                checked={answers[index] === 'NO'}
                onChange={() => handleRadioChange(index, 'NO')}
              />
              <label>NO</label>
            </div>
          </div>
        ))}
      </div>

      {/* Accept All Button */}
      <div className="accept-all">
        <button type="button" onClick={handleAcceptAll}>Accept All</button>
      </div>

      {/* Consent Checkbox */}
      <div className="consent">
        <label>
          <input 
            type="checkbox" 
            checked={consentChecked} 
            onChange={handleConsentChange} 
          />
          I consent to the collection, use, and disclosure of my personal data and training records to companies that access the Ministry of Manpower (MOM)’s Training Record System (TRS).
        </label>
      </div>
{attendance && (
  <p className="att-submit">Attendance Submitted Successfully</p>
)}
      {/* Submit Button */}
      <div className="submit">
        <button 
          type="button" 
          onClick={handleSubmit} 
          disabled={!acceptedAll || !consentChecked} 
        >
          Review and Submit
        </button>
      </div>
    </div>
  );
};

export default DeclarationForm;
